import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../shared/common-services/shared.service';

@Component({
  selector: 'app-external-initialization',
  templateUrl: './external-initialization.component.html',
  styleUrls: ['./external-initialization.component.scss']
})
export class ExternalInitializationComponent implements OnInit {

  isUrlIdAvailable: boolean = false;
  isError: boolean = false;

  private _externalToken: string;

  constructor(
    private _Activatedroute: ActivatedRoute,
    private _sharedService: SharedService,
    private _router: Router) { }

  ngOnInit(): void {
    this._Activatedroute.paramMap.subscribe(params => {
      if (params.get('id')) {
        this.isUrlIdAvailable = true;
        localStorage.clear();
        sessionStorage.clear();
        this._externalToken = params.get('id');
        this.externalLogin();
      } else {
        this.isUrlIdAvailable = false;
      }
    });
  }

  /* External Authentication */
  externalLogin() {
    if (this._sharedService.fetchTokenDetials(this._externalToken, true)) {
      this._router.navigateByUrl(this._sharedService?.getPrivilegeUrl());
    } else {
      this._sharedService.toastrHandler({ type: 'error', msg: '' });
      this._router.navigateByUrl('user-authentication/login');
    }
  }
}
